module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-gatsby-cloud/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Edeka Gutscheine","short_name":"its","description":"EDEKA Gutscheine bestellen I EDEKA Handelsgesellschaft Minden-Hannover mbH","lang":"de","start_url":"/","background_color":"#484746","theme_color":"#484746","display":"standalone","icon":"static/resources/img/logos/edeka_logo.png","legacy":false,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"373f542143939e561fe5609c728155fd"},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
